module.exports = __webpack_public_path__ + "static/img/y_szrl41.e535c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_szrl41.png
// module id = zTE7
// module chunks = 73